import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { showSweetAlert } from "./SweetAlert";

const PaymentSuccess = () => {
    const location = useLocation(); 
    const navigate = useNavigate();
    const [userLoginData, setUserLoginData] = useState('')

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        const userId = localStorage.getItem('userId');
        const fetchDataAndUpdate = async () => {
            const urlParams = new URLSearchParams(location.search);
            const session_id = urlParams.get('session_id');
    
            try {
                // Fetch transaction details from fixed domain (no subdomain dependency)
                const response = await axios.get(
                    `https://userapi.nodojicommodities.com/custom-apis/get-transaction-details?session_id=${session_id}`
                );
                if(response.status === 200){
                    const paidAt = localStorage.getItem('paidAt');
                    const planDuration = localStorage.getItem('planDuration');
                    const expiryAt = localStorage.getItem('expiryAt');
                    const paymentType = localStorage.getItem('paymentType');
                    const name = localStorage.getItem('userName');

                    const payment_info = {
                        transactionId: response.data.transaction_id,
                        plan_type: paymentType,
                        plan_duration: planDuration, // Monthly or Annually
                        amount: response.data.amount_total,
                        paid_at: paidAt,
                        expiry_at: expiryAt, // Expiry date from local storage
                    };

                    // Update user with payment info
                    const updateResponse = await axios.put(
                        `${process.env.REACT_APP_API_URL}/user/${userId}`,
                        { payment_info, name },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                'Content-Type': 'application/json',
                            },
                        }
                    );

                    if (updateResponse.status === 200) {
                        console.log('User payment info updated successfully');
                    } else {
                        console.log('Failed to update user payment info');
                    }
                }
            } catch (error) {
                console.error('Error fetching user data or updating payment info:', error);
            }
        };

        const fetchuserData = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            setUserLoginData(response.data)
        }
    
        fetchDataAndUpdate();
        fetchuserData();
    }, [location.search]); // Include dependencies    

    const handleContinue = () => {
        if(userLoginData.account_status === 'in_progress'){
            showSweetAlert('Warning!', `You account is in progress. Please try login again later.`, 'warning');
            console.log('Warning');
            localStorage.clear();
            navigate('/');
            return;
        }
        else if(userLoginData.account_status === 'signed_up'){
            showSweetAlert('Warning!', `You account is being set up. Please try login again later.`, 'warning');
            console.log('Warning');
            localStorage.clear();
            navigate('/');
            return;
        }
        else if(userLoginData.account_status === 'setup_failed'){
            showSweetAlert('Error!', `Failed to setup the account. Please try login again later.`, 'error');
            console.log('Error');
            localStorage.clear();
            navigate('/');
            return;
        }
        else if(userLoginData.account_status === 'setup_done'){
            navigate("/Home/Landing");
        } 
    }

    return (
        <div className="login-container">
            <Card className="payment-success-card gradient-border">
                <Card.Body>
                    <div className="text-center mb-5 mt-2">
                        <img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="App-logo" alt="logo" />
                    </div>
                    <Row className="text-center">
                        <Col sm={12}>
                            <img 
                            style={{ height: "60px", width: "60px"}} 
                            src={`${process.env.PUBLIC_URL}/images/green_check.svg`} 
                            alt="green_check" 
                            className="mb-2" 
                            />
                        </Col>
                        <Col sm={12}>
                            <p style={{ fontSize: '24px', margin: '10px 0', color: "white" }}>Payment Successful</p>
                        </Col>
                        <Col sm={12}>
                            <p style={{ fontSize: '20px', margin: '10px 0', color: "white" }}>Welcome, your professional plan is active now</p>
                        </Col>
                        <div>
                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    className="mt-3 w-100 p-2 theme-btn"
                                    onClick={handleContinue}
                                >
                                    Continue to platform {/* Change button text based on loading state */}
                                </Button>
                            </div>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );

};

export default PaymentSuccess;